export function getWindowLocation() {
  return window.location;
}